import { useDecision } from '@optimizely/react-sdk'
import moment from 'moment'
import { useSelector } from 'react-redux'

import type { BasketAddress } from 'reducers/basket'
import {
  getBasketDate,
  getChosenAddress,
  getNumPortions,
  isBasketTransactionalOrder,
} from 'selectors/basket'

export const GOUSTO_ANYTIME_FLAG = 'tomatoes_ofx_webclient_gousto_anytime'

export const formatBoxSize = (numPortions: number | undefined): string =>
  numPortions ? `${numPortions} people` : ''

export const formatDeliveryDayShort = (basketDate: string | undefined): string => {
  if (!basketDate) return ''
  const m = moment(basketDate)

  return m.isValid() ? m.format('ddd D MMM') : ''
}

export const formatDeliveryDayLong = (basketDate: string | undefined): string => {
  if (!basketDate) return ''
  const m = moment(basketDate)

  return m.isValid() ? m.format('dddd Do MMM') : ''
}

export const formatPostcode = (address: BasketAddress | undefined): string =>
  address?.get('postcode') ?? ''

export const formatFullAddress = (address: BasketAddress | undefined): string => {
  if (!address) return ''
  const line1 = address.get('line1')
  const town = address.get('town')
  const postcode = address.get('postcode')

  return [line1, [town, postcode].filter(Boolean).join(' ')].filter(Boolean).join(', ')
}

export type DeliverySettings = {
  isEnabled: boolean
  boxSize: string
  deliveryDayShort: string
  deliveryDayLong: string
  postcode: string
  fullAddress: string
}

export const useDeliverySettings = (): DeliverySettings => {
  const [decision] = useDecision(GOUSTO_ANYTIME_FLAG)
  const numPortions = useSelector(getNumPortions)
  const basketDate = useSelector(getBasketDate)
  const chosenAddress = useSelector(getChosenAddress)
  const isTransactionalOrder = useSelector(isBasketTransactionalOrder)

  // TODO: will also be gated on the user being in the experiment variant once the menu API exposes that
  return {
    isEnabled: Boolean(decision?.enabled) && isTransactionalOrder,
    boxSize: formatBoxSize(numPortions),
    deliveryDayShort: formatDeliveryDayShort(basketDate),
    deliveryDayLong: formatDeliveryDayLong(basketDate),
    postcode: formatPostcode(chosenAddress),
    fullAddress: formatFullAddress(chosenAddress),
  }
}
